import type { SVGProps } from "react";

/**
 * mute-fill, sound-off, audio
 * @category Sound & Music
 */
export default function IconMuteFill(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' fill='none' aria-hidden {...props}>
      <path
        d='M20.7071 4.70711C21.0976 4.31658 21.0976 3.68342 20.7071 3.29289C20.3166 2.90237 19.6834 2.90237 19.2929 3.29289L17 5.58579V5.13505C17 3.43938 15.0223 2.51306 13.7196 3.59861L9.91608 6.76823C9.73637 6.91799 9.50984 7.00001 9.2759 7.00001H8C6.34315 7.00001 5 8.34315 5 10V14C5 14.9778 5.46778 15.8463 6.19177 16.394L3.29289 19.2929C2.90237 19.6834 2.90237 20.3166 3.29289 20.7071C3.68342 21.0976 4.31658 21.0976 4.70711 20.7071L20.7071 4.70711Z'
        fill='currentColor'
      />
      <path
        d='M10.5133 17.7295L17 11.2429V18.865C17 20.5606 15.0223 21.487 13.7196 20.4014L10.5133 17.7295Z'
        fill='currentColor'
      />
    </svg>
  );
}
